import { render } from "./Episodio.vue?vue&type=template&id=d005aa66"
import script from "./Episodio.vue?vue&type=script&lang=js"
export * from "./Episodio.vue?vue&type=script&lang=js"

import "./Episodio.vue?vue&type=style&index=0&id=d005aa66&lang=css"

import exportComponent from "D:\\Hobby\\Javascript\\Sito_AS\\aperispeak\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__